import { t } from '@/i18n';
import { PresetTextField } from './PresetTextField';

interface DeltaFormattingSectionProps {
  deltaPrefix?: string;
  deltaSuffix?: string;
  useMillionsDelta?: boolean;
  millionsFromDelta?: number;
  decimalPlacesDelta?: number | null;
  onChange: (field: string, value: unknown) => void;
  testIdPrefix: string;
}

function numberValue(value: number | null | undefined): string | number {
  return value ?? '';
}

export function DeltaFormattingSection({
  deltaPrefix,
  deltaSuffix,
  useMillionsDelta,
  millionsFromDelta,
  decimalPlacesDelta,
  onChange,
  testIdPrefix,
}: DeltaFormattingSectionProps) {
  return (
    <div>
      <h6>{t('dashboard.widget.labeled_list.section.deltaFormatting')}</h6>

      <PresetTextField
        label="dashboard.widget.indicator.field.deltaPrefix"
        value={deltaPrefix ?? ''}
        onChange={(v) => onChange('deltaPrefix', v)}
        testId={`${testIdPrefix}-delta-prefix`}
        testIdPrefix={`${testIdPrefix}-delta-prefix`}
      />

      <PresetTextField
        label="dashboard.widget.indicator.field.deltaSuffix"
        value={deltaSuffix ?? ''}
        onChange={(v) => onChange('deltaSuffix', v)}
        testId={`${testIdPrefix}-delta-suffix`}
        testIdPrefix={`${testIdPrefix}-delta-suffix`}
      />

      <div className="mb-3">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            data-testid={`${testIdPrefix}-use-millions-delta`}
            id={`${testIdPrefix}-use-millions-delta`}
            checked={!!useMillionsDelta}
            onChange={(e) => onChange('useMillionsDelta', e.target.checked)}
          />
          <label className="form-check-label" htmlFor={`${testIdPrefix}-use-millions-delta`}>
            {t('dashboard.widget.indicator.field.useMillionsDelta')}
          </label>
        </div>
      </div>

      {!!useMillionsDelta && (
        <div className="mb-3">
          <label className="form-label">{t('dashboard.widget.indicator.field.millionsFromDelta')}</label>
          <input
            type="number"
            className="form-control"
            data-testid={`${testIdPrefix}-millions-from-delta`}
            value={numberValue(millionsFromDelta ?? null)}
            onChange={(e) => onChange('millionsFromDelta', e.target.value === '' ? null : Number(e.target.value))}
          />
        </div>
      )}

      <div className="mb-3">
        <label className="form-label">{t('dashboard.widget.indicator.field.decimalPlacesDelta')}</label>
        <input
          type="number"
          className="form-control"
          data-testid={`${testIdPrefix}-decimal-places-delta`}
          value={numberValue(decimalPlacesDelta ?? null)}
          onChange={(e) => onChange('decimalPlacesDelta', e.target.value === '' ? null : Number(e.target.value))}
        />
      </div>
    </div>
  );
}
